/**
 * Captures widget referral params (wref, wsid) from URL on landing
 * and persists them in first-party cookies for 30 days.
 *
 * Uses window.location.search directly (not Vue Router) to guarantee
 * raw URL params are available regardless of hydration timing.
 *
 * Also watches for client-side navigations with wref (e.g. user
 * navigates within the SPA after landing from a widget click).
 */
export default defineNuxtPlugin(() => {
  captureWidgetRef()

  const router = useRouter()
  router.afterEach((to) => {
    if (to.query.wref) {
      captureWidgetRef()
    }
  })
})

function captureWidgetRef() {
  const params = new URLSearchParams(window.location.search)
  const wref = params.get('wref')
  const wsid = params.get('wsid')

  if (wref) {
    const expires = new Date()
    expires.setTime(expires.getTime() + 30 * 24 * 60 * 60 * 1000) // 30 days
    document.cookie = `_tripening_wref=${encodeURIComponent(wref)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`

    if (wsid) {
      document.cookie = `_tripening_wsid=${encodeURIComponent(wsid)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`
    }
  }
}
